export default __webpack_public_path__ + "static/media/sidebar-4.dd4b5581.jpg";